import { render, staticRenderFns } from "./Kristall.vue?vue&type=template&id=05d3efa2&"
import script from "./Kristall.vue?vue&type=script&lang=js&"
export * from "./Kristall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports